import { render, staticRenderFns } from "./StripeRedirect.vue?vue&type=template&id=366d479d"
import script from "./StripeRedirect.vue?vue&type=script&lang=ts"
export * from "./StripeRedirect.vue?vue&type=script&lang=ts"
import style0 from "./StripeRedirect.vue?vue&type=style&index=0&id=366d479d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports